import React from 'react';
import { CircleCheckIcon, CircleXIcon } from 'lucide-react';
import { afterItems, beforeItems, differenceStats } from '../data/content';
export function Difference() {
  return <section className="w-full bg-cream px-5 py-20 sm:py-28" data-id="element-47" data-mp="a5t49fsozck">
      <div className="mx-auto max-w-5xl" data-id="element-48" data-mp="9vz8armq81l">
        <div className="mx-auto max-w-3xl text-center" data-id="element-49" data-mp="58z5tzn9cmbo">
          <span className="text-[11px] font-bold uppercase tracking-[0.18em] text-brand" data-id="element-50" data-mp="57ebob4uv5ec">
            The English Ready Difference
          </span>
          <h2 className="mt-5 font-display text-[2rem] font-black leading-[1.08] tracking-tight text-ink sm:text-5xl" data-id="element-51" data-mp="3rgyq113k2cba">
            From an Overwhelmed Teacher to an{' '}
            <span className="italic text-brand" data-id="element-52" data-mp="3dj0qh1tw8kfu">Inspired Guide.</span>
          </h2>
          <p className="mx-auto mt-5 max-w-xl text-sm leading-relaxed text-ink/60 sm:text-base" data-id="element-53" data-mp="3ihv5rtsnjqv7">
            Give your lessons a clear academic rhythm, your students more
            critical confidence, and yourself the time to enjoy teaching again.
          </p>
        </div>

        <dl className="mx-auto mt-11 grid max-w-3xl grid-cols-1 overflow-hidden rounded-xl border border-ink/10 bg-white sm:grid-cols-3" data-id="element-54" data-mp="1j9m62hjjkwap">
          {differenceStats.map((stat, index) => <div key={stat.label} className={`px-6 py-7 text-center ${index > 0 ? 'border-t border-ink/10 sm:border-l sm:border-t-0' : ''}`} data-id="element-55" data-mp="1sznj8eacwuau" data-mpi={index}>
              <dt className="sr-only" data-id="element-56" data-mp="wapoux6iqye7">{stat.label}</dt>
              <dd data-id="element-57" data-mp="wcai8jh3kbah">
                <span className="block font-display text-3xl font-black text-brand" data-id="element-58" data-mp="wcsnu6png1v2">
                  {stat.value}
                </span>
                <span className="mt-1.5 block text-[10px] font-bold uppercase tracking-[0.14em] text-ink/50" data-id="element-59" data-mp="15auvv67svuru">
                  {stat.label}
                </span>
              </dd>
            </div>)}
        </dl>

        <div className="mt-14 overflow-hidden rounded-3xl bg-white shadow-soft" data-id="element-60" data-mp="2gphwuy2i2mw5">
          <div className="grid md:grid-cols-2" data-id="element-61" data-mp="2os0lcg9ylmwv">
            <div className="relative bg-sand p-8 sm:p-10" data-id="element-62" data-mp="2otboqezhssng">
              <span className="absolute right-8 top-8 inline-flex h-9 w-9 items-center justify-center rounded-full bg-white text-ink/40" data-id="element-63" data-mp="2srsx11ung96g">
                <CircleXIcon className="h-5 w-5" aria-hidden="true" data-id="element-64" data-mp="2xpug3ms2s8hx" />
              </span>
              <span className="text-[10px] font-bold uppercase tracking-[0.16em] text-ink/45" data-id="element-65" data-mp="32q8ox71i3mh0">
                The cost of improvising
              </span>
              <h3 className="mt-3 font-display text-2xl font-bold tracking-wide text-ink" data-id="element-66" data-mp="2a1t94iajp04m">
                BEFORE
              </h3>
              <p className="mt-3 max-w-xs text-xs leading-relaxed text-ink/55" data-id="element-67" data-mp="2ezuw3eb3djld">
                What planning from scratch quietly takes from you.
              </p>
              <ul className="mt-7 space-y-3" data-id="element-68" data-mp="1mda1m4zbkrdl">
                {beforeItems.map(item => <li key={item} className="flex items-center gap-3 rounded-full bg-white/70 px-4 py-3 text-sm text-ink/65" data-id="element-69" data-mp="1rbbl2r0nqspl">
                    <CircleXIcon className="h-4 w-4 shrink-0 text-ink/35" aria-hidden="true" data-id="element-70" data-mp="1etipcw9nbg7n" />
                    {item}
                  </li>)}
              </ul>
            </div>

            <div className="relative bg-white p-8 sm:p-10" data-id="element-71" data-mp="14utidyjafg66">
              <span className="absolute right-8 top-8 inline-flex h-9 w-9 items-center justify-center rounded-full bg-brand text-white" data-id="element-72" data-mp="10tq1d8pi7e3d">
                <CircleCheckIcon className="h-5 w-5" aria-hidden="true" data-id="element-73" data-mp="w1gigcmt3eal" />
              </span>
              <span className="text-[10px] font-bold uppercase tracking-[0.16em] text-brand" data-id="element-74" data-mp="r46lmbx380cq">
                The English Ready system
              </span>
              <h3 className="mt-3 font-display text-2xl font-bold tracking-wide text-ink" data-id="element-75" data-mp="h60hdnnt6i4p">
                WITH ENGLISH READY
              </h3>
              <p className="mt-3 max-w-xs text-xs leading-relaxed text-ink/55" data-id="element-76" data-mp="d4p0q7mwx78n">
                Walk in with a clear, academic plan.
              </p>
              <ul className="mt-7 space-y-3" data-id="element-77" data-mp="16u5w4iy4huhf">
                {afterItems.map(item => <li key={item} className="flex items-center gap-3 rounded-xl bg-brand-light/60 px-4 py-3 text-sm font-medium text-ink" data-id="element-78" data-mp="t2hpuwak208d">
                    <CircleCheckIcon className="h-4 w-4 shrink-0 text-brand" aria-hidden="true" data-id="element-79" data-mp="j4bku5tgcdza" />
                    {item}
                  </li>)}
              </ul>
            </div>
          </div>
          <p className="border-t border-ink/5 bg-cream/60 px-6 py-4 text-center text-xs text-ink/50" data-id="element-80" data-mp="a5q7qq6r1r5w">
            A complete system to plan less and teach with more purpose.
          </p>
        </div>
      </div>
    </section>;
}